/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProgramMaturityControlRowDto } from './ProgramMaturityControlRowDto';
import {
    ProgramMaturityControlRowDtoFromJSON,
    ProgramMaturityControlRowDtoFromJSONTyped,
    ProgramMaturityControlRowDtoToJSON,
    ProgramMaturityControlRowDtoToJSONTyped,
} from './ProgramMaturityControlRowDto';

/**
 * 
 * @export
 * @interface ProgramMaturityControlListDto
 */
export interface ProgramMaturityControlListDto {
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityControlListDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityControlListDto
     */
    functionCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramMaturityControlListDto
     */
    catalogSupported?: boolean;
    /**
     * 
     * @type {Array<ProgramMaturityControlRowDto>}
     * @memberof ProgramMaturityControlListDto
     */
    rows?: Array<ProgramMaturityControlRowDto>;
}

/**
 * Check if a given object implements the ProgramMaturityControlListDto interface.
 */
export function instanceOfProgramMaturityControlListDto(value: object): value is ProgramMaturityControlListDto {
    return true;
}

export function ProgramMaturityControlListDtoFromJSON(json: any): ProgramMaturityControlListDto {
    return ProgramMaturityControlListDtoFromJSONTyped(json, false);
}

export function ProgramMaturityControlListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramMaturityControlListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'functionCode': json['functionCode'] == null ? undefined : json['functionCode'],
        'catalogSupported': json['catalogSupported'] == null ? undefined : json['catalogSupported'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(ProgramMaturityControlRowDtoFromJSON)),
    };
}

export function ProgramMaturityControlListDtoToJSON(json: any): ProgramMaturityControlListDto {
    return ProgramMaturityControlListDtoToJSONTyped(json, false);
}

export function ProgramMaturityControlListDtoToJSONTyped(value?: ProgramMaturityControlListDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frameworkSlug': value['frameworkSlug'],
        'functionCode': value['functionCode'],
        'catalogSupported': value['catalogSupported'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(ProgramMaturityControlRowDtoToJSON)),
    };
}

